import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemContentProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const ItemContent = ({ className, ref, ...props }: ItemContentProps) => (
  <div
    ref={ref}
    data-slot="item-content"
    className={cn("flex flex-1 flex-col gap-1 [&+[data-slot=item-content]]:flex-none", className)}
    {...props}
  />
);
